import axios from "axios";
import { AUTH_API_CONTEXT_PATH } from "../apiContextPath";
import { getDefaultBuConfig } from "../apiUtil";
import { generateTraceId } from "./util/AxiosInstanceUtil";

const authAxiosInstance = axios.create({
    baseURL: AUTH_API_CONTEXT_PATH,
    timeout: getDefaultBuConfig<number>('REACT_APP_CONNECTION_TIME_OUT') ?? 20000,
    headers: { "Content-Type": "application/json" }
})

authAxiosInstance.interceptors.request.use((config) => {
    // Modify the config object to include the token in the headers
    if (config.headers) {
        config.headers.Authorization = `Bearer ${localStorage.getItem("access_token_with_refresh")}`;
        config.headers.BuToken = `${localStorage.getItem("access_bu_token")}`;
        config.headers["X-Trace-Id"] = generateTraceId();
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

authAxiosInstance.defaults.timeout = getDefaultBuConfig<number>('REACT_APP_CONNECTION_TIME_OUT') ?? 20000;

export default authAxiosInstance;